import type { Control, FieldValues } from "react-hook-form";

import FormSection from "~/components/formElements/FormSection";
import Textarea from "~/components/formElements/Textarea";

type Props<T extends FieldValues> = {
	control: Control<T>;
};

interface BillingInstructionsFormData {
	billingInstructions: string | null;
}

const BillingInstructionsFormSection = <T extends BillingInstructionsFormData>({
	control,
}: Props<T>) => {
	return (
		<FormSection title="Abrechnungshinweise">
			<Textarea
				control={control}
				name="billingInstructions"
				placeholder="Hier können Hinweise zu besonderen Abrechnungsmodalitäten eingetragen werden"
			/>
		</FormSection>
	);
};

export default BillingInstructionsFormSection;
